<template>
<div>

</div>
</template>

<script>
export default {
  name: "SettingsView"
}
</script>

<style scoped>

</style>